// This icon file is generated automatically.
var PtoHomeFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M29.58 15.78L16.7 2.92a1 1 0 00-1.42 0L2.42 15.78a2 2 0 001.41 3.42H5.2v9.18a1 1 0 001 1H14v-7h3.5v7h8.3a1 1 0 001-1V19.2h1.37a2 2 0 001.41-3.42z", "fill-rule": "nonzero" } }] }, "name": "pto-home", "theme": "filled" };
export default PtoHomeFilled;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoHomeFilled.js
// module id = 3898
// module chunks = 0